import React, { Fragment } from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import GratuityNominees from "./Nominees/Nominees";
import { getAddressDetails } from "../../../util/candidateDataFilters";
import {
  getGenderName,
  getMaritalName,
  getFormattedDate,
  getAddressAsString,
  getFullName
} from "../../../util/helpers";
import { getStateName } from "../../../util/onBoardingDataFilters";
import useValidation from "../../../util/useValidation";
import {
  ADDRESS_TYPES,
  DECLARATION_PLACES
} from "../../../constants/constants";

const GratuityFormF = ({
  genders,
  maritalStatusList,
  personalDetails,
  relationShipList,
  states,
  addGratuityDetails,
  deleteGratuityDetails,
  updateNomineeDetails,
  updatePersonalDetails
}) => {
  const {
    addresses,
    religion,
    whereEmployeed,
    familyMembers,
    gratuityNomination
  } = personalDetails;
  const fullName = getFullName(personalDetails);

  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const {
    city,
    district,
    id,
    postOffice,
    state,
    subDivision,
    thana
  } = getAddressDetails("permanent", addresses);

  const handleOnChangePersonalDetails = (
    { target: { name, value } },
    isAddress = false
  ) => {
    if (isAddress) {
      updatePersonalDetails(name, value, "addresses", id);
    } else if (name === "declarationPlace") {
      updatePersonalDetails(name, parseInt(value));
    } else {
      updatePersonalDetails(name, value);
    }
  };

  const handleOnChangeGratuityDetails = (
    { target: { name, value } },
    memberId
  ) => {
    updateNomineeDetails(
      name,
      value.trimStart(),
      "gratuityNomination",
      memberId
    );
  };
  const handleOnSelectedNominee = memberId => {
    const newNominee = {
      familyMemberId: memberId,
      gratuityProprotionShared: "",
      candidateId: personalDetails.id
    };
    addGratuityDetails(newNominee);
  };

  const handleOnDeleteNominee = deletedNomineeId => {
    deleteGratuityDetails(deletedNomineeId);
  };

  return (
    <Fragment>
      <Card>
        <Card.Header className="text-center">Gratuity Form-F</Card.Header>
        <Card.Body>
          <div>
            <p>To,</p>
            <div className="m-4">
              <span>CDK Global</span>
              <p className="mt-1">
                1. I, Shri/ Shrimati /Kumari <b>{fullName}</b> ( name in full
                here ) whose particulars are given in the statement below,
                hereby nominate the person(s) mentioned below to receive the
                gratuity payable after my death as also the gratuity standing to
                my credit in the event of my death before the amount as become
                payable, has not been paid and direct that the said amount of
                gratuity shall be paid in proportion indicated against the
                name(s) of the nominee(s).
              </p>
              <p>
                2. I hereby certify that the person(s) mentioned is a /are
                member(s) of my family within the meaning of clause (h) of
                section 2 of the payment of gratuity Act, 1972.
              </p>
              <p>
                3. I hereby declare that I have no family within the meaning of
                clause (h) of Section 2 of the said Act.
              </p>
              <p>
                4. (a) My father /mother parents is /are not dependent on me.
              </p>
              <p className="pl-3 ml-1">
                (b) My husband’s father /mother /parents is /are not dependent
                on my husband.
              </p>
              <p>
                5. I have excluded my husband from my family by a notice dated
                the ……………… to the Controlling Authority in terms of the
                provision to clause (h) of section 2 of the said Act
              </p>
              <p>
                6. Nomination made herein invalidates my previous nomination.
              </p>
            </div>
          </div>
          <GratuityNominees
            familyMembers={familyMembers}
            relationShipList={relationShipList}
            gratuityNomination={gratuityNomination}
            handleOnSelectedNominee={handleOnSelectedNominee}
            handleOnDeleteNominee={handleOnDeleteNominee}
            handleOnChangeGratuityDetails={handleOnChangeGratuityDetails}
          />
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Body>
          <div className="ml-3">
            <Form.Group as={Row} controlId="nameOfEmployee">
              <Form.Label column sm={4}>
                1. Name of the employee in full*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  disabled
                  name="nameOfEmployee"
                  required
                  size="sm"
                  type="text"
                  value={fullName}
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="sex">
              <Form.Label column sm={4}>
                2. Sex*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  disabled
                  size="sm"
                  required
                  type="text"
                  name="sex"
                  value={getGenderName(personalDetails.gender, genders)}
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="religion">
              <Form.Label column sm={4}>
                3. Religion*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  size="sm"
                  required
                  type="text"
                  name="religion"
                  onChange={handleOnChangePersonalDetails}
                  value={religion}
                  onBlur={handleOnBlurInput}
                  isInvalid={errors.religion}
                />
                {errors.religion && (
                  <Form.Control.Feedback type="invalid">
                    {errors.religion.type === "required" &&
                      "Religion is required"}
                  </Form.Control.Feedback>
                )}
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="isMarried">
              <Form.Label column sm={4}>
                4. Whether unmarried / married/ widow/ widower*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  disabled
                  size="sm"
                  required
                  type="text"
                  name="isMarried"
                  value={getMaritalName(
                    personalDetails.maritalStatus,
                    maritalStatusList
                  )}
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="departmentOfEmployee">
              <Form.Label column sm={4}>
                5. Department/ Branch/ Section Where employed
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  name="whereEmployeed"
                  size="sm"
                  disabled
                  type="text"
                  value="CDK Global"
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="postHeldByTicket">
              <Form.Label column sm={4}>
                6. Post held with Ticket or serial No.if any*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  size="sm"
                  disabled
                  type="text"
                  name="cDKDesignation"
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="dateOfAppointment">
              <Form.Label column sm={4}>
                7. Date of Appointment*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  size="sm"
                  required
                  type="date"
                  name="dateOfAppointment"
                  value={getFormattedDate(
                    personalDetails.dateofJoining,
                    undefined,
                    "YYYY-MM-DD"
                  )}
                  readOnly
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group as={Row} controlId="permanentAddress">
              <Form.Label column sm={4}>
                8. Permanent Address*
              </Form.Label>
              <Col sm={4} className="pt-1">
                <Form.Control
                  size="sm"
                  required
                  rows={3}
                  as="textarea"
                  name="permanentAddress"
                  value={getAddressAsString(
                    ADDRESS_TYPES.PERMANENT,
                    addresses,
                    states
                  )}
                  disabled
                />
              </Col>
              <Col sm={4} />
            </Form.Group>
            <Form.Group
              as={Row}
              className="ml-2 mt-3 justify-content-start"
              controlId="villageThanaSubDivision"
            >
              <Col sm={3}>
                <Form.Label>Village</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="city"
                  value={city}
                  onChange={e => {
                    handleOnChangePersonalDetails(e, true);
                  }}
                />
              </Col>
              <Col sm={3}>
                <Form.Label>Thana</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="thana"
                  value={thana}
                  onChange={e => {
                    handleOnChangePersonalDetails(e, true);
                  }}
                />
              </Col>
              <Col sm={3}>
                <Form.Label>Sub-Division</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="subDivision"
                  value={subDivision}
                  onChange={e => {
                    handleOnChangePersonalDetails(e, true);
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="ml-2 justify-content-start"
              controlId="postOfficeDistrictState"
            >
              <Col sm={3}>
                <Form.Label>Post Office</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="postOffice"
                  value={postOffice}
                  onChange={e => {
                    handleOnChangePersonalDetails(e, true);
                  }}
                />
              </Col>
              <Col sm={3}>
                <Form.Label>District</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="district"
                  value={district}
                  onChange={e => {
                    handleOnChangePersonalDetails(e, true);
                  }}
                />
              </Col>
              <Col sm={3}>
                <Form.Label>State*</Form.Label>
                <Form.Control
                  disabled
                  size="sm"
                  required
                  type="text"
                  name="state"
                  value={getStateName(state, states)}
                  onChange={e => {
                    handleOnChangePersonalDetails(e, true);
                  }}
                />
              </Col>
            </Form.Group>
          </div>
        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>
          <Row>
            <Col sm={4}>
              <Form.Label>Place*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="declarationPlace"
                value={personalDetails.declarationPlace}
                onChange={e => {
                  handleOnChangePersonalDetails(e, false);
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.declarationPlace}
              >
                <option value="">Choose...</option>
                {DECLARATION_PLACES.map(place => (
                  <option value={place.id}>{place.name}</option>
                ))}
              </Form.Control>
              {errors.declarationPlace && (
                <Form.Control.Feedback type="invalid">
                  {errors.declarationPlace.type === "required" &&
                    "Place is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={8}></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <Form.Label>Date*</Form.Label>
              <Form.Control
                readOnly
                size="sm"
                required
                type="date"
                name="date"
                value={getFormattedDate(new Date(), undefined, "YYYY-MM-DD")}
              />
            </Col>
            <Col sm={4}></Col>
            <Col sm={4}>
              <Form.Label>Signature*</Form.Label>
              <Form.Control
                disabled
                size="sm"
                required
                type="text"
                name="signature"
                value={fullName}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>Declaration by witnesses</Card.Header>
        <Card.Body>
          <p>Nomination signed / thumb-impression before me.</p>
          <p> Name in full and full address of witness</p>
          <Row>
            <Col sm={8}></Col>
            <Col sm={4}>Signature of witness*</Col>
          </Row>
          <Row>
            <Col sm={8}>
              <p>1.</p>
              <p>2.</p>
            </Col>
            <Col sm={4}>
              <p>1.</p>
              <p>2.</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>Place</p>
              <p>Date</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>Certify by the Employer</Card.Header>
        <Card.Body>
          <p>
            Certified that the particulars of the above nomination have been
            verified and recorded in this establishment.
          </p>
          <p>Employer’s reference No., if any</p>
          <Row>
            <Col sm={4}>Date</Col>
            <Col sm={4}></Col>
            <Col sm={4}>
              <p>Signature of the Employer/ Officer</p>
              <p>Authorized Designation</p>
            </Col>
          </Row>
          <Row>
            <Col sm={8}></Col>
            <Col sm={4}>
              <p>
                Name and Address of the establishment or Rubber stamp thereof
              </p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default GratuityFormF;
